import { inject } from '@angular/core'
import { CanDeactivateFn } from '@angular/router'

import { TranslateService } from '@ngx-translate/core'

import { StepModeFacadeService } from './step-mode-facade.service'

export const stepModeLeaveGuard: CanDeactivateFn<unknown> = () => {
  const facade = inject(StepModeFacadeService)
  const translate = inject(TranslateService)
  const step = facade.currentStep()

  if (step?.step_type !== 'ai' || !facade.isAgentStreaming()) {
    return true
  }

  return window.confirm(translate.instant('step_mode.confirm_leave_ai_generating'))
}
